<template>
    <div>
        <div class="banner">
            <div class="headerReplacementAnalystInfo"></div>
            <div class="banner-text">
                <b>{{ $t('analyst.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('analyst.breadcrumb.home') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('analyst.breadcrumb.section') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('analyst.breadcrumb.current') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="TabMenu">
                <AnalystInfoTabMenu />
            </div>
            <div class="table-responsive">
                <table class="table mt-3 mb-5">
                    <thead>
                        <tr class="table-secondary">
                            <th scope="col"><b>{{ $t('analyst.table.company') }}</b></th>
                            <th scope="col"><b>{{ $t('analyst.table.name') }}</b></th>
                            <th scope="col"><b>{{ $t('analyst.table.email') }}</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ กสิกรไทย จำกัด (มหาชน)</th>
                            <td>คุณ สรพงษ์ จักรธีรังกูร</td>
                            <td>sorapong.j@kasikornsecurities.com</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ภัทร จำกัด (มหาชน)</th>
                            <td>คุณ นฤมล เอกสมุทร</td>
                            <td>narumon.ekas@kkpfg.com</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ กรุงศรี พัฒนสิน จำกัด (มหาชน)</th>
                            <td>คุณ สมนันท์ ผลสมบูรณ์โชค</td>
                            <td>samanun.polsomboonchok@krungsricapital.com</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ซีจีเอส-ซีไอเอ็มบี (ประเทศไทย) จำกัด</th>
                            <td>คุณ ภรณ์ทิพาญ์ ยับแสงเดือน</td>
                            <td>pornthipa.ra@cgs-cimb.com</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ เคจีไอ (ประเทศไทย) จำกัด (มหาชน)</th>
                            <td>คุณ วนิดา ไกสเล่อร์</td>
                            <td>vanidag@kgi.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ฟินันเซีย ไซรัส จำกัด (มหาชน)</th>
                            <td>คุณ ธัญญธร ทรงวุฒิ</td>
                            <td>thanyatorn.s@fnsyrus.com</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ หยวนต้า (ประเทศไทย) จำกัด</th>
                            <td>คุณ อทิตยา ชินะกาญจนดิษฐ์</td>
                            <td>Athitaya.c@yuanta.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัท หลักทรัพย์ ดาโอ (ประเทศไทย) จำกัด (มหาชน)</th>
                            <td>คุณ อำนาจ โงสว่าง</td>
                            <td>amnart.n@daol.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ยูโอบี เคย์เฮียน (ประเทศไทย) จำกัด (มหาชน)</th>
                            <td>คุณ เกษมสันต์ คุณนะรา</td>
                            <td>Kasemsun@uobkayhian.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ โกลเบล็ก จำกัด</th>
                            <td>คุณ วิลาสินี บุญมาสูงทรง</td>
                            <td>wilasinee@globlex.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ เอเซีย พลัส จำกัด</th>
                            <td>คุณ นวลพรรณ น้อยรัชชุกร</td>
                            <td>nuanpun@asiaplus.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)</th>
                            <td>คุณ นรภัทร เหลืองสมบูรณ์</td>
                            <td>norrapat.lu@lhsec.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ทิสโก้ จำกัด</th>
                            <td>คุณ ณัฐวุฒิ ศิวะรุจิวงศ์</td>
                            <td>nathavut@tisco.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ฟิลลิป (ประเทศไทย) จำกัด มหาชน</th>
                            <td>คุณ ทศวรรณ ธรรมสุข</td>
                            <td>totsawant@phillip.co.th</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์พาย จำกัด (มหาชน)</th>
                            <td>คุณ ภัคจิรา มานะตั้ง​สกุล​กิจ</td>
                            <td>pakjira.ma@pi.financial</td>
                        </tr>
                        <tr>
                            <th scope="row">บริษัทหลักทรัพย์ ซี แอล เอส เอ (ประเทศไทย) จำกัด</th>
                            <td>คุณ ลีนา แพรักขกิจ</td>
                            <td>leena.phaerakkakit@CLSA.com</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
  
<script>
import AnalystInfoTabMenu from '@/components/AnalystInfoTabMenu.vue';

export default {
    name: 'Info',
    components: {
        AnalystInfoTabMenu,
    },
    data() {
        return {
        };
    },
    methods: {
    },

};
</script>
<style scoped>
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}


.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;

}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}
</style>
  
  